<div class="card mt-20" style="border: none; position: relative; height: 100%">
  <h5 class="card-header">New Discount Details</h5>
  <div class="card-body">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div>
        <span> <b>Discount Period: </b> {{ period }} </span>
      </div>
      <div style="gap: 10px; display: flex">
        <button
          class="btn btn-light"
          style="background-color: #5864ff; color: white"
          (click)="addMrr()"
        >
          Add Discount Details
        </button>
        <!-- <button *ngIf="!isAnyRowSelected" type="button" class="btn btn-outline-danger" (click)="deleteall = true">Delete All</button> -->
        <!-- <button *ngIf="isAnyRowSelected" type="button" class="btn btn-outline-danger" (click)="deleteSel()">Delete Selected</button> -->
      </div>
    </div>
    <mrr-tabs
      #mrrTabsRef
      [accountId]="accountId"
      [urlPrefix]="urlPrefix"
      [mid]="mid"
    >
    </mrr-tabs>
  </div>
</div>

<new-all-update
  *ngIf="updateMRR"
  [action]="updateAction"
  [mrr]="updateMRR"
  [unsaved]="unsavedMRR"
  (hideModel)="closeUpdateTrigger($event)"
  [mrrData]="mrrData"
  [mrrDatasub]="mrrDatasub"
  [mid]="mid"
  [subEc2]="subEc2"
  [subRds]="subRds"
  [s3Mrr]="s3Mrr"
  [cfrcMrr]="cfrcMrr"
  [s3Keys]="s3Keys"
  [cfrcKeys]="cfrcKeys"
>
</new-all-update>
